import styled from 'styled-components';

const Button = styled.button`
    height: 32px;
    width: 32px;
    border-radius: 16px;
    border: 1px solid #DCE1E7;
    box-sizing: border-box;
    background: transparent;
    &:focus {
        outline: none;
    }
`

export default Button;